import React, {useEffect, useState} from 'react';
import PreviousNextButton from "../../../../../components/PreviousNextButton";
import {useIntl} from "react-intl";
import {Grid, Stack, TextField} from "@mui/material";
import Keyboard from "../../../../../components/keyboard/Keyboard";
import {VMS_WEB_SOCKET_HOST_PASSPORT} from "../../../../../constants/Profile";

// 中安证件识别系统
let passportReaderSocket: WebSocket;
let passportReaderInterval: NodeJS.Timeout;

export type CheckinIdNumberInputProps = {
    onPrevious: () => void;
    onNext: (idNumber: string) => void;
    value?: string;
};

const CheckinIdNumberInput: React.FC<CheckinIdNumberInputProps> = (props) => {
    const intl = useIntl();

    const [idNumber, setIdNumber] = useState('');

    useEffect(() => {
        if (props.value) {
            setIdNumber(props.value);
        }
    }, []);

    useEffect(() => {

        // 连接Id Card Web Socket
        connectPassportReaderSocket();

        // 销毁WebSocket连接和定时器
        return () => {
            console.log("Will UnMount")
            if (passportReaderSocket) {
                console.log("passportReaderSocket close")
                passportReaderSocket.close();
                if (passportReaderInterval) {
                    console.log("clearInterval passportReaderInterval")
                    clearInterval(passportReaderInterval);
                }
            }
        }

    }, []);

    // 建立和PassportReader之间的连接
    const connectPassportReaderSocket = () => {
        // init the websocket client
        if (passportReaderSocket != null) {
            passportReaderSocket.close();
        }

        passportReaderSocket = new WebSocket(VMS_WEB_SOCKET_HOST_PASSPORT + "/echo");

        /* 成功建立websocket连接 */
        passportReaderSocket.onopen = function () {
            getWebConstants();
            setDefaultSettings();
        }

        /* 响应后台服务的应答报文或通知报文 */
        passportReaderSocket.onmessage = function (event) {
            let retmsg = event.data;
            console.error(retmsg);
            let jsonMsg;

            try {
                jsonMsg = JSON.parse(retmsg);
                if (jsonMsg.Type === 'Notify') {
                    processNotify(jsonMsg);
                }
                return;
            } catch (exception) {
                // document.getElementById("msg").innerHTML = "Parse error: " + event.data;
            }
        }

        /* 主动或被动关闭websocket连接时触发，清空页面信息 */
        passportReaderSocket.onclose = function () {
            if (passportReaderSocket !== null) {
                passportReaderSocket.close();
            }
        }

        /* websocket出错事件，清空页面信息并报警 */
        passportReaderSocket.onerror = function (evt) {
            console.error(evt);
        }
    };

    /* 后台服务主动向web端发送消息，包括读卡信息、证件图像以及异常状态通知等 */
    const processNotify = (msgNotify: JSON) => {
        // @ts-ignore
        if (msgNotify.Command === 'Save') {
            // @ts-ignore
            if (msgNotify.Operand === 'CardContentText') {
                // @ts-ignore
                displayCardContent(msgNotify.Param);
            }
        }
    }

    /*  解析证件文本信息（JSON格式）并展示到页面 */
    const displayCardContent = (cardContent: Map<string, string>) => {
        console.log(cardContent);
        for (let key in cardContent) {
            if (key.indexOf("身份") > 0 || key.indexOf("护照") > 0) {
                // @ts-ignore
                setIdNumber(cardContent[key]);
            }
        }
    }

    const getWebConstants = () => {
        let request = {
            Type: "Request",
            Commands: [
                {Command: "Get", Operand: "WebConstant", Param: "CardRecogSystem"},
                {Command: "Get", Operand: "WebConstant", Param: "Connect"},
                {Command: "Get", Operand: "WebConstant", Param: "Disconnect"},
                {Command: "Get", Operand: "WebConstant", Param: "Save"},
                {Command: "Get", Operand: "WebConstant", Param: "IDCANCEL"},
                {Command: "Get", Operand: "WebConstant", Param: "DeviceStatus"},
                {Command: "Get", Operand: "WebConstant", Param: "DeviceName"},
                {Command: "Get", Operand: "WebConstant", Param: "DeviceSerialno"},
                {Command: "Get", Operand: "WebConstant", Param: "DeviceNotConnected"},
                {Command: "Get", Operand: "WebConstant", Param: "DescOfWebsocketError"},
                {Command: "Get", Operand: "WebConstant", Param: "DescFailSetRFID"},
                {Command: "Get", Operand: "WebConstant", Param: "DescFailSetVIZ"},
                {Command: "Get", Operand: "WebConstant", Param: "PlaceHolderCardTextInfo"},
                {Command: "Get", Operand: "WebConstant", Param: "DeviceOffLine"},
                {Command: "Get", Operand: "WebConstant", Param: "DeviceReconnected"},
                {Command: "Get", Operand: "WebConstant", Param: "DescFailSendWebsocket"},
                {Command: "Get", Operand: "WebConstant", Param: "WebDescDeviceNotFound"},
                {Command: "Get", Operand: "WebConstant", Param: "WebDescRequireRestartSvc"},
                {Command: "Get", Operand: "WebConstant", Param: "WebDescAskForSupport"},
                {Command: "Get", Operand: "WebConstant", Param: "WebDescRequireReconnect"},
                {Command: "Get", Operand: "WebConstant", Param: "DeviceConnected"}
            ]
        };

        sendJson(JSON.stringify(request));
    }

    /* 设置读卡参数，默认识别芯片信息、识别版面信息 */
    const setDefaultSettings = () => {
        let request = {
            Type: "Request",
            Commands: [
                {Command: "Set", Operand: "RFID", Param: "Y"}, /* 设置识别芯片信息 */
                {Command: "Set", Operand: "VIZ", Param: "Y"}   /* 设置识别版面信息 */
            ]
        };

        sendJson(JSON.stringify(request));
    }

    /* 将发送数据的操作做了封装 */
    const sendJson = (jsonData: string) => {
        try {
            if (passportReaderSocket !== null) {
                passportReaderSocket.send(jsonData);
            }
        } catch (exception) {
            //document.getElementById("msg").innerHTML = strDescFailSendWebsocket;
        }
    }

    const handleNext = async () => {
        if (idNumber) {
            props.onNext(idNumber);
        }
    }

    const handleKeyboardClick = (value: string) => {
        let newIdNumber = idNumber;
        if (value === 'del') {
            if (newIdNumber.length > 0) {
                newIdNumber = newIdNumber.substring(0, newIdNumber.length - 1);
            }
        } else {
            newIdNumber += value;
        }

        setIdNumber(newIdNumber);
    }

    return (
        <div>
            <Stack spacing={2} justifyContent={'space-around'} alignItems="center" style={{height: '60vh'}}>
                <div className={'self-terminal-visit-code-input'}>
                    <TextField label={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ID_NUMBER'})}
                               placeholder={intl.formatMessage({id: 'VMS_REQUEST_VISITOR_ID_NUMBER_REQUIRED'})}
                               variant="outlined"
                               InputLabelProps={{
                                   shrink: true,
                               }}
                               InputProps={{
                                   readOnly: true,
                               }}
                               fullWidth
                               value={idNumber}/>
                </div>
                <Keyboard onClick={(value) => handleKeyboardClick(value)}/>
                <PreviousNextButton onPrevious={() => props.onPrevious()} onNext={() => handleNext()}/>
            </Stack>
        </div>
    );
};

export default CheckinIdNumberInput;
